<!--
  Shared Dropdown Component
  A reusable dropdown styled with pill or standard variants.
  Supports generic options with custom display and value functions.
-->
<div
  class="shared-dropdown"
  [class.variant-pill]="variant() === 'pill'"
  [class.variant-standard]="variant() === 'standard'"
  [class.variant-structure]="variant() === 'structure'"
  [attr.data-test]="testIdPrefix()">

  <!-- Optional label -->
  @if (showLabel() && label()) {
    <label class="dropdown-label">{{ label() }}</label>
  }

  <!-- Dropdown wrapper for positioning -->
  <div class="dropdown-wrapper">
    <!-- Trigger button -->
    <button
      type="button"
      [class]="triggerClass()"
      [disabled]="disabled()"
      [attr.data-test]="testIdPrefix() + '_trigger'"
      [attr.aria-expanded]="isOpen()"
      aria-haspopup="listbox"
      [style.border-color]="borderColor()"
      [style.border-radius]="borderRadius() && !borderRadius()?.startsWith('rounded') ? borderRadius() : null"
      (click)="toggleDropdown()">
      <span class="trigger-text">{{ selectedDisplayText() }}</span>
      <aca-icon
        [icon]="icons.chevronDown"
        class="trigger-icon"
        [class.rotated]="isOpen()">
      </aca-icon>
    </button>

    <!-- Dropdown panel -->
    @if (isOpen()) {
      <div
        class="dropdown-panel"
        [class.align-right]="alignRight()"
        role="listbox"
        [attr.data-test]="testIdPrefix() + '_panel'"
        [attr.aria-label]="label() || 'Select an option'">
        <ul class="options-list">
          @for (option of options(); track option; let idx = $index) {
            <li
              class="dropdown-option"
              [class.selected]="isSelected(option)"
              role="option"
              [attr.aria-selected]="isSelected(option)"
              [attr.data-test]="testIdPrefix() + '_option_' + idx"
              (click)="selectOption(option); $event.stopPropagation()">
              <span class="option-text">{{ displayFn()(option) }}</span>
              @if (isSelected(option)) {
                <aca-icon [icon]="icons.check" class="check-icon"></aca-icon>
              }
            </li>
          }
        </ul>
      </div>
    }
  </div>
</div>

